import { ApiConfig, api } from '@cems-eco/core/src/services/api';
import environment from "@/config"

export abstract class BaseDocumentApi {
    BASE_URL: string;

    
    constructor() {
        this.BASE_URL = "/document";
    }

    async all(): Promise<any> {
        return await api.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await api.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await api.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await api.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async upload(data: any): Promise<any> {
        data = api.toFormData(data);
        const config: ApiConfig = {
            isAuth: true,
            isFormData: true
        }
        return await api.post<any>(`${this.BASE_URL}/upload`, data, config);
    }

    async uploadBulk(data: any): Promise<any> {
        data = api.toFormData(data);
        const config: ApiConfig = {
            isAuth: true,
            isFormData: true
        }
        return await api.post<any>(`${this.BASE_URL}/upload/bulk`, data, config);
    }

}
